export default __webpack_public_path__ + "static/media/profile.5f558e0f.png";